import { isValidSelectorString } from '@/utils/validations/selector.validation';
import { z } from 'zod';
import { ExtendedHotelRoomPricingSchema } from './HotelRoomPricingFormData';
import { HotelPensionPricingSchema } from './HotelPensionPricingSchema';

export const HotelRoomCategorySchema = ExtendedHotelRoomPricingSchema.extend({
  category: isValidSelectorString('La catégorie est requise'),
  complementaryInformation: isValidSelectorString(
    'Veuillez saisir des informations complémentaires',
  ).optional(),
  name: z
    .string({ message: 'Le nom est requis' })
    .min(1, { message: 'Le nom est requis' }),
  mainImage: z.union([z.instanceof(Blob), z.string(), z.null()]).optional(),
  images: z.array(z.union([z.instanceof(Blob), z.string()])),
  shortDescription: z.string().optional(),
  longDescription: z.string().optional(),
  roomTypes: z.object({
    individual: z.boolean().optional(),
    double: z.boolean().optional(),
    triple: z.boolean().optional(),
    quadruple: z.boolean().optional(),
  }),
  individualRoomOptions: z.array(z.coerce.number().int().min(0).max(0)).max(1),
  doubleRoomOptions: z.array(z.coerce.number().int().min(0).max(2)).max(3),
  tripleRoomOptions: z.array(z.coerce.number().int().min(0).max(5)).max(6),
  quadrupleRoomOptions: z.array(z.coerce.number().int().min(0).max(9)).max(10),
  categoryPensionPricings: z
    .array(HotelPensionPricingSchema)
    .optional()
    .default([]),
});

export const ExtendedHotelRoomCategorySchema = z.object({
  hotelRoomCategories: z.array(HotelRoomCategorySchema).min(1),
});

export type ExtendedHotelRoomCategoryFormData = z.infer<
  typeof ExtendedHotelRoomCategorySchema
>;
